"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSignaturePad = void 0;
const tslib_1 = require("tslib");
const react_1 = require("react");
const signature_pad_1 = (0, tslib_1.__importDefault)(require("signature_pad"));
function useSignaturePad({ onChange, value, name, readOnly }) {
    const ref = (0, react_1.useRef)(null);
    let signaturePad;
    let width = 0, height = 0;
    const renderSignature = (dataUrl) => {
        if (ref.current) {
            const context = ref.current.getContext('2d');
            const image = new Image();
            image.onload = () => {
                if (!ref.current)
                    return;
                context.drawImage(image, 0, 0, ref.current.offsetWidth, ref.current.offsetHeight);
            };
            image.src = dataUrl;
            if (readOnly)
                signaturePad.off();
        }
    };
    const handleResize = (dataUrl) => {
        if (ref.current) {
            const context = ref.current.getContext('2d');
            const ratio = Math.max(window.devicePixelRatio || 1, 1);
            ref.current.width = ref.current.offsetWidth * ratio;
            ref.current.height = ref.current.offsetHeight * ratio;
            context.scale(ratio, ratio);
            if (signaturePad)
                signaturePad.clear(); // otherwise isEmpty() might return incorrect value
            width = ref.current.width;
            height = ref.current.height;
            if (dataUrl)
                renderSignature(dataUrl);
            else if (value && value.isSigned)
                renderSignature(value.dataUrl);
        }
        else {
            // fix for unmounted component not unmounting properly
            if (signaturePad)
                signaturePad.off();
            window.removeEventListener('resize', onResize);
        }
    };
    const handleSignatureChange = () => {
        if (ref.current && signaturePad) {
            const signature = {
                isSigned: !signaturePad.isEmpty(),
                // replace signature with empty pixel
                dataUrl: signaturePad.isEmpty()
                    ? 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
                    : signaturePad.toDataURL(),
                type: 'image/png',
                canvas: {
                    width: ref.current.width,
                    height: ref.current.height
                }
            };
            if (name && onChange) {
                onChange(Object.assign({}, { name }, signature));
            }
            else {
                if (onChange)
                    onChange(signature);
            }
            return signature;
        }
    };
    const onResize = (e) => {
        handleResize();
    };
    const clearSignature = () => {
        if (signaturePad) {
            signaturePad.clear();
            if (readOnly)
                signaturePad.off();
        }
        return handleSignatureChange();
    };
    const setSignature = (signature) => {
        if (onChange)
            onChange(signature);
        handleResize(signature.dataUrl);
    };
    (0, react_1.useEffect)(() => {
        if (signaturePad && value)
            handleResize(value.dataUrl);
        if (ref.current && !signaturePad) {
            signaturePad = new signature_pad_1.default(ref.current, {
                onEnd: handleSignatureChange
            });
            if (readOnly)
                signaturePad.off();
            handleResize();
            window.addEventListener('resize', onResize);
        }
        return () => {
            if (signaturePad)
                signaturePad.off();
            window.removeEventListener('resize', onResize);
        };
    }, [value, readOnly]);
    (0, react_1.useEffect)(() => {
        if (signaturePad) {
            readOnly === true ? signaturePad.off() : signaturePad.on();
        }
    }, [signaturePad, readOnly]);
    return {
        ref,
        setSignature: (0, react_1.useCallback)((signature) => setSignature(signature), [signaturePad]),
        clearSignature: (0, react_1.useCallback)(() => clearSignature(), [signaturePad])
    };
}
exports.useSignaturePad = useSignaturePad;
//# sourceMappingURL=useSignaturePad.js.map